import { render, staticRenderFns } from "./trailerMenu.vue?vue&type=template&id=7bb4cae0&scoped=true"
var script = {}
import style0 from "./trailerMenu.vue?vue&type=style&index=0&id=7bb4cae0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb4cae0",
  null
  
)

export default component.exports